<template>
  <!-- Mobile Toggle Button -->
  <!-- <button class="sidebar-toggle" @click="isSidebarOpen = true">
        <i class="fas fa-bars"></i>
    </button> -->

  <!-- Sidebar -->
  <aside
    class="sidebar"
    :class="{ 'show': isOpen }"
  >
    <!-- Close Button -->
    <li
      class="close-btn"
      @click="$emit('close')"
    >
      <i class="fas fa-times" />
    </li>
    <div class="sidebar-header">
      <i class="fas fa-chevron-down me-2" /> SELECT YOUR DESIRE
    </div>
    <ul class="sidebar-menu">
      <li
        class="sidebar-item"
        data-category="deals"
      >
        <router-link :to="{ name: 'FlashSaleGallery' }">
          <i class="fas fa-tags" />
          <h3>Deals</h3>
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link :to="{ name: 'Trending' }">
          <i class="fas fa-fire" />
          <h3>Trending</h3>
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/discount">
          <i class="fas fa-percentage" />
          <h3>Discounts</h3>
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link :to="{ name: 'Popular' }">
          <i class="fas fa-thumbs-up" />
          <h3>Popular</h3>
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/content/help-center">
          <i class="fas fa-comment" />
          <h3>Support</h3>
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/content/faq">
          <i class="fas fa-question-circle" />
          <h3>FAQ</h3>
        </router-link>
      </li>
      <li
        v-for="item in categories"
        :key="item.id"
        class="sidebar-item"
        data-category="mooncake"
      >
        <router-link :to="{ path: '/gallery/' + item.slug }">
          <img
            :src="item.image"
            :title="'The image representation for ' + item.name"
            :alt="'The image representation for ' + item.name"
            style="width: 20px; height: auto;"
          >
          <span>{{ item.name }}</span>
          <!-- <span class="new-badge">NEW</span> -->
          <!-- <span class="hot-badge">HOT</span> -->
        </router-link>
      </li>
    </ul>
  </aside>
  <!-- Overlay -->
  <div
    v-if="isOpen"
    class="sidebar-overlay"
    @click="$emit('close')"
  />
</template>


<script>
import $ from 'jquery';
import axios from '@/utils/axiosConfig';

export default {
    name: 'Categories',
    props: {
        isOpen: { type: Boolean, default: false }
    },
    data() {
        return {
            categories: [],
            loaded: false,
            // isSidebarOpen: false,
        };
    },
    mounted() {
        this.getCategory();
        window.addEventListener('scroll', this.handleSidebarScroll);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleSidebarScroll);
    },
    methods: {
        handleSidebarScroll() {
            const sidebar = document.querySelector('.sidebar');
            const scrollTop = window.scrollY || window.pageYOffset;
            const initialTop = 130; // initial offset

            if (scrollTop > initialTop) {
                sidebar.style.top = '0px';
                sidebar.style.height = '100vh'; // full height
            } else {
                sidebar.style.top = initialTop + 'px';
                sidebar.style.height = `calc(100vh - ${initialTop}px)`; // adjust height
            }
        },
        getCategory() {
            axios.get('categories')
                .then((response) => {
                    if (response.data.success) {
                        this.categories = response.data.data;
                    }
                })
                .catch((err) => {
                    console.error('Failed to fetch categories:', err);
                });
        }
    },
};
</script>